module.exports = __webpack_public_path__ + "media/images/clock-13b6265cf94b5ef34a8af79c57d7a04f.png";